var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import MuiLink from '@mui/material/Link';
/**
 * Pigment [Link](https://pigment.customink.com/?path=/docs/components-link)
 */
export var Link = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var button = _a.button,
    component = _a.component,
    forwardableProps = __rest(_a, ["button", "component"]);
  return /*#__PURE__*/React.createElement(MuiLink, __assign({
    component: button ? 'button' : component,
    ref: ref
  }, forwardableProps));
});
export default Link;